import { render, staticRenderFns } from "./BaseButtonDropdown.vue?vue&type=template&id=516e3855&"
import script from "./BaseButtonDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseButtonDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports